import React from 'react';
import MultiSelect from './MultiSelect';
import { withStyles} from '@material-ui/core';

class JiraStatusFilter extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            multiValue: []
          };
        this.statusOptions = [{ value: 2, label: "ToDo" }, { value: 0, label: "Under review" }, { value: 1, label: "Approved" },{ value: 3, label: "REOPENED" },{ value: 4, label: "Rejected" }];
      }

      handleJiraStatusFilterChange=(selectedValue)=>{
          this.setState({multiValue:selectedValue});
          this.props.filterPatientStatus(selectedValue,"status");
      };
      componentDidUpdate(prevProps){
        if(prevProps.patientList !== this.props.patientList){
          this.handleJiraStatusFilterChange([]);
        }
     }

      render(){
          return(
              <>
                <MultiSelect
                options={this.statusOptions}
                name={"JiraStatus"}
                isMulti
                checkBoxStyled
                onChange={this.handleJiraStatusFilterChange}
                value={this.state.multiValue}
                isSearchable = {false}
                isClearable = {false}
                placeholder = {this.state.multiValue&&this.state.multiValue.length>0?"Jira Status ":"Jira Status : All "}
                textFieldProps={{
                  variant:"outlined",
                  label:''
              }}
                >
                </MultiSelect>
              </>
          );
      }
}

export default (withStyles()(JiraStatusFilter));